import { logNetworkRequest } from 'Diagnostics/diagnostics';
import requestConfig from 'Models/uiConfig/requestConfig';
import { convertibleFromObject } from 'Modules/converter/index';

import { facetsToConvertible } from './common/convert';
import { GET, getErrorFacetsResponse } from './common/httpClient';
import ResponseValidationError from './common/responseValidationError';
import { isFacetsResponseShape } from './common/validators';
import { FACETS_ENDPOINT } from './endpoints';
import type { SearchRequest, ServerModel } from './types';

export { isFacetsResponseShape as isFacetsResponse } from './common/validators';

const { requestDefaults } = requestConfig;

export default async function facets(
  request: SearchRequest,
  abortSignal: AbortSignal,
): Promise<ServerModel.FacetsResponse> {
  const extra = {
    ...(requestDefaults.extra ?? {}),
    ...(request.extra ?? {}),
  };

  try {
    const raw = await GET(
      FACETS_ENDPOINT,
      {
        facet: facetsToConvertible(request),
        extra: await convertibleFromObject(extra),
        referrer: request.referrer ?? requestDefaults.referrer ?? '',
      },
      { signal: abortSignal },
    );
    if (!isFacetsResponseShape(raw)) {
      throw new ResponseValidationError(`${FACETS_ENDPOINT} response missing 'Facets' array`);
    }
    return raw;
  } catch (error) {
    console.warn(error || 'Facets request failed');
    logNetworkRequest({ endpoint: FACETS_ENDPOINT, scenario: 'request_error', primaryError: error });
    return getErrorFacetsResponse(error);
  }
}
